import { render, staticRenderFns } from "./AppVersionTableRow.vue?vue&type=template&id=d53f39dc&"
import script from "./AppVersionTableRow.vue?vue&type=script&lang=js&"
export * from "./AppVersionTableRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports